module.exports = __webpack_public_path__ + "a5e0eeba6e7a53b434a642992d24d9df.glb";